import { useState } from 'react';

import { useQuery } from '@tanstack/react-query';

import { call } from '@spacefill/shared/src/utils/Backend';
import { Combobox } from '@spacefill/uikit/src/components/Combobox/Combobox';
import { Loader } from '@spacefill/uikit/src/components/Loader';
import { safeLocalStorage } from '@spacefill/uikit/src/utils/storage';

export function AdminCompanySwitcher() {
    const [searchQuery, setSearchQuery] = useState('');
    const [loading, setLoading] = useState(false);

    const { data: dataCustomerLsp } = useQuery({
        queryKey: ['admin/list-customers-lsp', searchQuery],
        queryFn: async () => call('admin/list-customers-lsp', { name: searchQuery }, 'POST'),
    });

    return (
        <Combobox
            placeholder={'Choose a customer/Lsp'}
            options={dataCustomerLsp || []}
            formatOption={(value) => {
                return (
                    <>
                        [{value.value.type.slice(0, 1)}] {value.value.name}
                    </>
                );
            }}
            accessoryElement={loading ? <Loader size='small' /> : null}
            setValue={async (value) => {
                if (value) {
                    await call(
                        '/users/',
                        {},
                        'GET',
                        value.type === 'CUSTOMER' ? { 'x-customer-id': value.id } : { 'x-lsp-id': value.id }
                    );
                    setLoading(true);
                    safeLocalStorage.clear();
                    window.location = '';
                }
            }}
            onSearch={(query) => {
                setSearchQuery(query);
            }}
        />
    );
}
